<h1 mat-dialog-title>
  <i [class]="data.icon ?? 'pi pi-fw pi-cog text-primary'"></i>
  {{ data.titulo }}
</h1>
<div mat-dialog-content>
  <h6
    class="mb-2 font-weight-light"
    [style]="data.breakline ? 'white-space: pre;' : 'white-space: normal;'"
    *ngIf="data.bodyMessage"
  >
    {{ data.bodyMessage }}
  </h6>
  <div *ngFor="let msg of data.regras" class="flex flex-column">
    <div class="flex align-items-center mt-2">
      <mat-icon color="primary" class="mr-2">info</mat-icon>
      <span>{{ msg.regra }}</span>
    </div>
    <div class="flex flex-column mt-1" style="width: 400px;">
      <p class="fs-small text-justify">{{ msg.descricao }}</p>
    </div>
  </div>
</div>
<div matDialogActions class="mt-2 justify-content-center">
  <button mat-flat-button color="primary" mat-dialog-close>
    Entendi
  </button>
</div>
